module.exports = __webpack_public_path__ + "img/9791195218134.da1e0979.jpg";